// Libs
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Utils

// Styles
import './styles/all.scss';

// Components

// App
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
